import React, { useEffect } from "react";
import { connect } from "react-redux";
import { 
    AlertCircle,
    ArrowLeft,
    CircleCheck,
    Clock,
    Handshake,
    Plus,
} from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import PopupButton from "components/button/PopupButton";
import SupportTicket from "./components/SupportTicket";
import SupportTabs from "./components/SupportTabs";
import { useNavigate, useLocation } from "react-router-dom";
import {
    getTicketDepartmentMatrix
} from "../../../../redux/overview/overviewState";

const PartnerService = ({ getList, recordList }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const navFromQuickAccess = location.state?.fromQuickAccess;

    useEffect(() => {
        getList(); 
    }, [getList]);

    const psDepartment = recordList?.find(d => d.department_name === "PS");
    
    const open = psDepartment?.open || 0;
    const inProgress = psDepartment?.in_progress || 0;
    const resolved = psDepartment?.resolved || 0;

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">

                {navFromQuickAccess && (
                    <button
                        onClick={() => navigate("/console/dashboard")}
                        className="flex items-center border rounded-xl px-2 py-1 gap-2 dark:text-white mb-4"
                    >
                        <ArrowLeft className="w-4 h-4 dark:text-white"/>
                        Back to Dashboard
                    </button>
                )}

                <SummaryHeader
                    title={"Partner Service"}
                    icon={Handshake}
                    description={"Billing, contracts, and partnership support"}
                    color={"bg-purple"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Submit Partner Service Ticket"
                            description="Get assistance with billing, contracts, and partnership inquiries"
                            label="New Ticket" 
                            btnClass="ticket btn-ticket purple" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <SupportTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Open Tickets"
                            icon={<AlertCircle />}
                            display={open}
                        />
                        <SummaryItem
                            title="In Progress"
                            icon={<Clock />}
                            display={inProgress} 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display={resolved} 
                        />
                   </div>
                </SummaryHeader>
                <SupportTabs />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    // Same as HRSupport - access the data property
    recordList: state.overview.ticketDepartmentMatrix?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getList: (filters) => dispatch(getTicketDepartmentMatrix(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnerService);